import * as Sentry from '@sentry/browser';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { SENTRY_URL } from './constants/links';
import Root from './containers/Root/Root';
import configureStore from './store/configureStore';
import { bootAnonymousIntercom } from './utilities/intercom';

const config = configureStore();
export const store = config.store;

Sentry.init({
  dsn: SENTRY_URL,
  ignoreErrors: ['ResizeObserver loop limit exceeded'],
});

bootAnonymousIntercom();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Root store={config.store} persistor={config.persistor} />);
